//libs
import { useContext } from 'react';

//components
import CustomTitleSelect from './custom-title-select';

//types
import { StoresContext } from '../../../../App';

const features = {
    Special: 'Specialty store',
    DIY: 'DIY',
    WebStore: 'Online store',
    Wholesale: 'Wholesale',
    PanelAssembly: 'Electrical panel assembly',
};

const featureOptions = Object.entries(features).map(([code, name]) => ({
    name,
    value: { code, value: null },
}));

export default function PartnerTypes() {
    const { featureFilters, setFeatureFilters } =
        useContext(StoresContext);
    const selectedFeature = features[featureFilters[0]?.code as keyof typeof features] || '';

    return (
        <div className="feature-filter-block partner-type-filter-block">
            <div className="partner-type-filter-block__list partner-type-filter-block-list partners-select-item">
                <CustomTitleSelect
                    name="Select partner type"
                    value={selectedFeature}
                    options={featureOptions}
                    onChange={(val) => setFeatureFilters(val ? [val] : [])}
                />
            </div>
        </div>
    );
};